export const MESSAGE_STATUSES = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SENT: 'SENT',
  READ: 'READ',
};
